/* eslint-env browser */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Announcement } from './components';
import { getAnnouncement, setAnnouncementCounter } from './utils/announcements';
import { getEmojis, removeEmojisFromString } from './utils/emoji';

class SlidingPopUp extends Component {
  state = {
    announcementIsVisible: true,
    announcement: null
  };

  componentDidMount() {
    this.setAnnouncement();
  }

  setAnnouncement() {
    const announcement = getAnnouncement(this.props.announcements);
    const { durationForDisplaying } = this.props;
    if (announcement) {
      const { title } = announcement;
      announcement.emojis = getEmojis(title);
      announcement.title = removeEmojisFromString(announcement.emojis, title);
      setTimeout(() => this.setState({ announcement }), durationForDisplaying);
    }
  }

  closeAnnouncement = announcementId => {
    setAnnouncementCounter(announcementId, 99);
    this.setState({ announcementIsVisible: false });
  };

  render() {
    const { source } = this.props;
    const { announcementIsVisible, announcement } = this.state;
    return (
      <div>
        {announcementIsVisible &&
        announcement && (
          <Announcement
            id={announcement.id}
            subject={announcement.title}
            description={announcement.description}
            link={announcement.link}
            cta={announcement.cta}
            onClose={this.closeAnnouncement}
            onClick={this.closeAnnouncement}
            source={source}
            emojis={announcement.emojis}
          />
        )}
      </div>
    );
  }
}

SlidingPopUp.defaultProps = {
  announcements: null,
  durationForDisplaying: 1 * 10000 // 10 seconds
};

SlidingPopUp.propTypes = {
  announcements: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      cta: PropTypes.string.isRequired,
      probability: PropTypes.number.isRequired,
      maxTimesDisplayed: PropTypes.number.isRequired,
      startDateForDisplaying: PropTypes.string.isRequired,
      finishDateForStopDisplaying: PropTypes.string.isRequired
    })
  ),
  durationForDisplaying: PropTypes.number,
  source: PropTypes.string.isRequired
};

export default SlidingPopUp;



// WEBPACK FOOTER //
// ./src/index.js